import { Slot } from '@radix-ui/react-slot'

import { cn } from '~/utils/cn'
import { type VariantProps, tv } from '~/utils/tv'

type CaptionProps = React.ComponentPropsWithRef<'caption'> &
  VariantProps<typeof captionVariants> & {
    asChild?: boolean
  }

const captionVariants = tv({
  base: 'inline font-sans text-threepulse/medium tracking-normal no-underline',
  variants: {
    variant: {
      'default-bold': null,
      'underline-bold': null,
      'default-semibold': null,
      'underline-semibold': null,
    },
  },
  compoundVariants: [
    {
      variant: ['default-bold', 'underline-bold'],
      class: 'font-bold',
    },
    {
      variant: ['default-semibold', 'underline-semibold'],
      class: 'font-semibold',
    },
    {
      variant: ['underline-bold', 'underline-semibold'],
      class: 'underline',
    },
  ],
  defaultVariants: {
    variant: 'default-bold',
  },
})

function Caption({ variant, asChild, ...props }: CaptionProps) {
  const Comp = asChild ? Slot : 'caption'

  return (
    <Comp
      {...props}
      className={cn(
        captionVariants({
          variant,
        })
      )}
    />
  )
}

export { Caption }
export type { CaptionProps }
